
























import { Vue, Component, Prop } from 'vue-property-decorator';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import SendProductPaymentRequestMessage from '@communications/components/forms/product-payment-request/send-product-payment-request-message.vue';
import { SendProductPaymentRequestMessageFormModel } from '@tools/interfaces/template';

@Component({
  components: {
    SendProductPaymentRequestMessage,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class SendProductPaymentRequestMessageDrawer extends Vue {
  declare $refs: {
    sendProductPaymentRequestMessage: InstanceType<typeof SendProductPaymentRequestMessage> & {
      formModel: SendProductPaymentRequestMessageFormModel;
    };
  };

  @Prop({ type: Boolean, default: false }) readonly showDrawer: boolean;
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly contactIds: number[];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedItemIds: number[];

  loading: boolean = false;
  errors: Record<string, string[]> = {};

  get defaultTemplateId(): number | null {
    if (this.entityName === 'subscription') {
      return this.$store.getters['centerSettings/centerSettings']
        ?.subscription_payment_request_email_template_id;
    }

    if (this.entityName === 'enrollment') {
      return this.$store.getters['centerSettings/centerSettings']
        ?.enrollment_payment_request_email_template_id;
    }

    return null;
  }

  get drawerTitle() {
    return this.$t('global.modals.send_product_payment_request_message.title').toString();
  }

  closeDrawer() {
    this.$emit('close-drawer');
  }

  onSendMessage() {
    this.loading = true;
    const url = this.$bpcApiRouteHelper.getEntityPath('messages');
    console.log('FORM MODEL ', this.$refs.sendProductPaymentRequestMessage.formModel);

    this.$bpcApi.post(url, this.$refs.sendProductPaymentRequestMessage.formModel).subscribe(
      res => {
        this.loading = false;
        this.closeDrawer();
      },
      error => {
        this.loading = false;
        this.errors = error?.response?.data?.errors || {};
      },
    );
  }
}
